import type {ReactElement} from 'react';
import React from 'react';
import type {TeamInviteUpsellingCardProps} from './team-invite-upselling-card.types';
import {Button, Size, Type} from '@Components/button';
import {Text, TextSize} from '@Components/text';
import styles from './team-invite-upselling-card.module.scss';

export function TeamInviteUpsellingCard({isMobile = false, className = ''}: TeamInviteUpsellingCardProps): ReactElement {
  return (
    <div className={`${className} ${styles.teamInviteUpsellingCard} ${isMobile ? 'flex-v-row' : 'flex-h-row'} _full-width flex-align-items-center`}>
      <div className="flex-v-row flex-1">
        <Text val={window.i18next.t('pmwjs_create_a_team')} className="content-heading" size={TextSize.XSMALL} bold />
        <Text val={window.i18next.t('pmwjs_work_together_with_team')} className="content-body" size={TextSize.XSMALL} />
      </div>
      <Button
        text={window.i18next.t('pmwjs_invite_team_members')}
        type={Type.SECONDARY}
        size={Size.XSMALL}
        icon="icon-group_add"
        customClasses={isMobile ? '_full-width' : ''}
        href={window.PMW.util.site_url('premium/subscriptions')}
      />
    </div>
  );
}
